<template>
  <span>
    <slot
      :disabled="disabled"
      :onClick="onExport"
    />
  </span>
</template>

<script>
import axios from "axios";
import {alert} from '@pnotify/core';
import catchDispatch from "@/utils/catchDispatch";
import {exportTasksModal} from "../../../services/chat/event/onMessageDump";

export default {
  props: {
    room: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      disabled: false,
    };
  },
  methods: {
    onExport() {
      if (this.disabled) return;
      this.disabled = true;

      const id = (new Date()).getTime();
      exportTasksModal[id] = alert({
        title: this.$t(`rooms.export.alert.start.title`),
        text: '<div class="progress"><div class="progress-bar progress-bar-striped progress-bar-animated" role="progressbar" aria-valuenow="0" aria-valuemin="0" aria-valuemax="100" style="width: 0%"></div></div>',
        textTrusted: true,
        addClass: 'btn-primary',
        icon: 'ri-loader-2-line spinner',
        hide: false,
        closer: true,
      });

      axios
        .get(`/chats/api/v1/chats/${this.room.id}/export`, {params: {task: id}})
        .catch(e => catchDispatch.call(this, e))
        .finally(() => this.disabled = false);
    },
  },
};
</script>

<style scoped>

</style>
